import { EventStats } from '../models/event'
import { apiRequest } from '../../utils/axios'

export interface UpdateEventStatusPayload {
  AccountId: number
  EventId: number
  InvoiceNumber: string
  StatusId: number
}

export async function fetchEvents(token: string): Promise<EventStats[]> {
  return apiRequest('GET', '/eventstatus', token)
}

export async function updateEventStatus(token: string, payload: UpdateEventStatusPayload): Promise<EventStats[]> {
  return apiRequest('PUT', '/eventstatus', token, payload)
}
